import FAQPage from 'components/FAQ/FAQPage'

export default FAQPage
